export const COMPANY = {
  name: "Waghe & Sons Food Pvt. Ltd.",
  shortName: "Waghe & Sons",
  tagline: "From Barwani to the World",
  since: "1965",
  address: "107 Jawahar Marg, Guruwa Mohalla, Barwani, Madhya Pradesh 451551, India",
  phones: ["+91 62616 37474", "+91 94248 94948"],
  phoneRaw: ["+916261637474", "+919424894948"],
  email: "info@waghefoods.com",
  whatsapp: "https://wa.me/916261637474",
  workforce: "50+",
  varieties: "60+",
};

export const whatsappLink = (text) =>
  `${COMPANY.whatsapp}?text=${encodeURIComponent(text)}`;

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/brands", label: "Our Brands" },
  { to: "/products", label: "Products" },
  { to: "/manufacturing", label: "Manufacturing & Quality" },
  { to: "/export-inquiry", label: "Export & Distributor" },
  { to: "/contact", label: "Contact" },
];

const px = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=940`;

export const IMAGES = {
  heroTexture:
    "https://images.unsplash.com/photo-1656055450593-5f9fc1e88b65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxnb2xkZW4lMjBhYnN0cmFjdCUyMGx1eHVyeSUyMHRleHR1cmV8ZW58MHx8fHwxNzg2NTI3MDQxfDA&ixlib=rb-4.1.0&q=85",
  darkTexture:
    "https://images.unsplash.com/photo-1594896733292-9a77b5809c63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxnb2xkZW4lMjBhYnN0cmFjdCUyMGx1eHVyeSUyMHRleHR1cmV8ZW58MHx8fHwxNzg2NTI3MDQxfDA&ixlib=rb-4.1.0&q=85",
  starAnise:
    "https://images.unsplash.com/photo-1554475659-edf5d531d08e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzcGljZXMlMjBibGFjayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg2NTI3MDIyfDA&ixlib=rb-4.1.0&q=85",
  exportContainers:
    "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxzaGlwcGluZyUyMGNvbnRhaW5lcnMlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzg2NTI3MDMyfDA&ixlib=rb-4.1.0&q=85",
  factory: px(36823725),
  factoryWorker: px(11679687),
  factoryHands: px(5953728),
  factoryLine: px(11679691),
  factoryTeam: px(5953804),
  spicesBowls: px(6808976),
  chiliSacks: px(31346441),
  turmeric: px(12122270),
  namkeenAssort: px(6576317),
  snackBags: px(38042377),
  nutDisplay: px(38803769),
  friedSticks: px(17480807),
  bananaChips: px(9832651),
};

export const STATS = [
  { value: "60+", label: "Signature Namkeen Varieties", testId: "stat-varieties" },
  { value: "1965", label: "Trusted Since", testId: "stat-since" },
  { value: "50+", label: "Skilled Workforce", testId: "stat-workforce" },
  { value: "100%", label: "Export Ready", testId: "stat-export" },
];

export const MARQUEE_ITEMS = [
  "Made in India",
  "Served Worldwide",
  "Trusted Since 1965",
  "60+ Signature Varieties",
  "Pure Spices & Premium Oil",
  "From Barwani to the World",
];

export const ASSETS = {
  banner: "/assets/banner.jpg",
  logoShree: "/assets/logo-waghe-shree.jpg",
  logoMint: "/assets/logo-tasty-mint.jpg",
  yash: "/assets/yash-waghe.jpg",
  hermendra: "/assets/hermendra-waghe.jpg",
};

export const LEADERSHIP = [
  {
    name: "Yash Waghe",
    role: "Director",
    lineage: "Son of Shyam Waghe",
    img: "/assets/yash-waghe.jpg",
    testId: "leader-yash-waghe",
  },
  {
    name: "Hermendra Waghe",
    role: "Director",
    lineage: "Son of Shyam Waghe",
    img: "/assets/hermendra-waghe.jpg",
    testId: "leader-hermendra-waghe",
  },
];
